export default "__VITE_ASSET__CjvF90gK__"